export function openClusterSection({ state }) {
  return { ...state, clusterCollapse: false };
}

export function collapseClusterSection({ state }) {
  return { ...state, clusterCollapse: true };
}
